export const breakpoints = {
    t: 1024,
    m: 768,
    s: 375
};

const respond = (keys: Array<keyof typeof breakpoints>, style:string) =>  {
    let result: string = '';
    keys.forEach((key) => {
        let i = 0;
        let previousView: keyof typeof breakpoints|null = null;
        Object.keys(breakpoints).some((point,index) =>  {
            if (key === point){
                i = index;
                return key === point;
            } else {
                previousView = point as keyof typeof breakpoints;
                return null;
            }
        });
        
        let isFirst = i === 0;
        let isLast = i === Object.keys(breakpoints).length - 1;

        if (isFirst) {
            result += `@media (min-width: ${breakpoints[key]}px) { ${style} }`;
        } else if (!isFirst && !isLast && previousView){
            result += `@media (min-width:${breakpoints[key]}px) and (max-width: ${breakpoints[previousView] - 1}px ) { ${style} }`;
        }else if (isLast && previousView) {
            result += `@media (max-width: ${breakpoints[previousView] - 1}px) { ${style} }`;
        }
    });

    return result;
};

export { respond };
